import { render, staticRenderFns } from "./systemDownload.vue?vue&type=template&id=b205c99e&"
import script from "./systemDownload.vue?vue&type=script&lang=js&"
export * from "./systemDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports